import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-analyticsloanrepaymenthistory',
  templateUrl: './analyticsloanrepaymenthistory.component.html',
  styleUrls: ['./analyticsloanrepaymenthistory.component.css']
})
export class AnalyticsloanrepaymenthistoryComponent implements OnInit {
  @Input('details') details: any;
  highest_interest: any;
  highest_tenor: any;
  highest_principal: any;
  loans_borrowed: any;
  times_late: any;
  early_repayment: any;
  loans_early: any;
  total_amt_borrowed: any;
snapshot: any;
  constructor() {
  }

  ngOnInit() {
    this.getLoansAnalytics();
  }

  getLoansAnalytics() {
    this.highest_interest = this.details.data.highestinterest;
    this.highest_tenor = this.details.data.highesttenor;
    this.highest_principal = this.details.data.highestprincipal;
    this.loans_borrowed = this.details.data.noofloansbooked;
    this.times_late = this.details.data.nooftimeslate;
    this.loans_early = this.details.data.nooftimesearly;
    this.total_amt_borrowed = this.details.data.sumofloansbooked;
    this.early_repayment = this.details.data.totalearly;
  }

}
